{
  "nameInput": {
    "placeholder": "What's your name?"
  },
  "signIn": {
    "tagline": "Begin with intention.",
    "signingIn": "Signing in…",
    "continueApple": "Continue with Apple",
    "continueApple_aria": "Continue with Apple",
    "continueGoogle": "Continue with Google",
    "continueGoogle_aria": "Continue with Google",
    "logo_alt": "Rhemn",
    "footer": "By signing in, you agree to our terms of service and <privacyLink>Privacy Policy</privacyLink>.",
    "divider": "or"
  },
  "email": {
    "identity": {
      "label": "Email address",
      "placeholder": "you@example.com",
      "change": "Change",
      "change_aria": "Change email address"
    },
    "password": {
      "label": "Password",
      "labelNew": "Choose a password",
      "placeholder": "Password",
      "placeholderNew": "Create a password",
      "show": "Show password",
      "hide": "Hide password"
    },
    "actions": {
      "continue": "Continue",
      "signIn": "Sign in",
      "createAccount": "Create account",
      "forgot": "Forgot password?",
      "backToSignIn": "Back to sign in",
      "iVerified": "I've verified my email",
      "resend": "Resend link",
      "resendIn": "Resend in {{time}}",
      "signInInstead": "Sign in instead"
    },
    "busy": {
      "checking": "Checking…",
      "signingIn": "Signing in…",
      "creating": "Creating your account…",
      "sending": "Sending…"
    },
    "switch": {
      "toCreate": "New to Rhemn? <switchBtn>Create an account</switchBtn>",
      "toSignIn": "Already have an account? <switchBtn>Sign in</switchBtn>"
    },
    "strength": {
      "tooShort": "At least 12 characters.",
      "level1": "Good. Longer is stronger.",
      "level2": "Strong password.",
      "level3": "Very strong password."
    },
    "sent": {
      "title": "Check your inbox",
      "body": "We sent a reset link to {{email}}. It expires in one hour.",
      "resent": "Sent again. Check your inbox."
    },
    "verify": {
      "title": "Confirm your email",
      "body": "We sent a link to {{email}}. Open it to finish setting up your account — we'll pick up from here automatically.",
      "waiting": "Waiting for you to open the link…",
      "resent": "Sent again. Check your inbox."
    },
    "errors": {
      "invalidEmail": "That doesn't look like an email address.",
      "missingPassword": "Enter your password.",
      "invalidCredential": "Email or password is incorrect.",
      "emailInUse": "That email already has an account. <signInBtn>Sign in instead.</signInBtn>",
      "weakPassword": "Use at least 12 characters.",
      "passwordTooShort": "Use at least 12 characters.",
      "passwordCommon": "That password is too easy to guess. Try something less predictable.",
      "emailNotVerified": "Confirm your email before continuing.",
      "providerGoogle": "This email is already set up with Google. Continue with Google below.",
      "providerApple": "This email is already set up with Apple. Continue with Apple below.",
      "userDisabled": "This account has been disabled.",
      "requiresRecentLogin": "Sign in again to make this change.",
      "sessionExpired": "Your session expired. Sign in again.",
      "expiredActionCode": "That link has expired. Request a new one.",
      "invalidActionCode": "That link is no longer valid. Request a new one.",
      "tooManyRequests": "Too many attempts. Wait a few minutes, or reset your password.",
      "network": "No connection. Check your network and try again.",
      "operationNotAllowed": "Email sign-in isn't available right now.",
      "generic": "Something went wrong. Please try again."
    },
    "a11y": {
      "stepEmail": "Step 1 of 2. Enter your email address.",
      "stepPasswordSignIn": "Step 2 of 2. Enter your password to sign in.",
      "stepPasswordCreate": "Step 2 of 2. Choose a password for your new account.",
      "stepSent": "Reset link sent. Check your inbox.",
      "stepVerify": "Account created. Verification link sent.",
      "resendReady": "You can resend the link now."
    }
  }
}
